<template>
    <div class="lg:w-1/2 m-auto">
        <setup-substep name="welcome-substep-1" next-text="Show me the solution →" @completed="done" open>
            <p class="my-2 font-bold">So, you're having some email troubles.</p>
            
            <p class="my-2">What do you relate with the most? This will help setup your account precisely for your needs.</p>

            <div class="mt-2 py-2 rounded-md bg-gray-light" v-for="(choice, index) in choices" :key="index">
                <input :id="choice.id" type="radio" name="choice" :value="choice.id" class="hidden" v-model="chosen">
                <label :for="choice.id" class="cursor-pointer">
                    <div class="flex items-start p-3">
                        <span class="indicator w-4 h-4 inline-block rounded-full border border-primary flex-shrink-0 bg-primary-lighter"></span>
                        <div class="ml-2 min-w-0">
                            <p class="leading-none">
                                {{ choice.label }}
                            </p>
                        </div>
                    </div>
                </label>
            </div>
            <div class="p-3 w-full bg-gray-light" v-if="chosen === 'custom'">
                <label for="trouble" class="">What is it?</label>
                <input type="text" name="trouble" id="trouble" class="my-1 border border-gray-dark border-b-2 p-2 rounded w-full" placeholder="Let us know your situation here..." v-model="custom">
                <p class="text-destructive" v-if="errors['trouble'] && errors['trouble'].length > 0">This cannot be empty.</p>
            </div>
                    
        </setup-substep>
    </div>
</template>

<script>
export default {
    id   : 'intention',
    icon : 'mail-bulk',
    label: 'Problem',

    data() {
        return {
            choices: [
                {
                    id: 'day-ends-up-in-inbox',
                    label: '📨 Most of my day ends up in my inbox.'
                },
                {
                    id: 'too-many-unwanted-emails',
                    label: '🤯 I get too many unwanted/spam emails.'},
                {
                    id: 'block-someone',
                    label: '🧨 I just want to block someone from emailing me.'
                },
                {
                    id: 'just-looking-around',
                    label: '🧐 I am just looking around.'
                },
                {
                    id: 'custom',
                    label: '🤕 Something else...'
                },
            ],

            chosen: null,
            custom: '',
            errors: {},
        }
    },
    
    methods: {
        done() {
            this.errors = {};
            axios.put('/api/me/notes', {
                trouble: this.getHumanReadableTrouble(),
            })
            .then(response => {
                console.log(response);
                this.$emit('done');
            })
            .catch(err => {
                this.errors = err.response.data.errors;
            });
        },

        getHumanReadableTrouble() {
            if (this.chosen === 'custom') return this.custom;

            var choice = _.find(this.choices, {id: this.chosen});
            return choice.label;
        }
    }

}
</script>